import { Fragment } from 'react';
import { id } from '@monorepo/tools/src/lib/types/primitives';

type IToggleCampaignStatuses = {
	advertisersIds: id[];
	action: string;
};
export const EnablePauseAdvertisersModal = (props: IToggleCampaignStatuses) => {
	const { advertisersIds, action } = props;
	return (
		<Fragment>
			<div>{action} the following advertisers:</div>
			<span style={{ color: '#4f46e5' }}>
				{advertisersIds.length < 6
					? advertisersIds.map(
							(advertiserId, index) => `${index !== advertisersIds.length - 1 ? advertiserId + ', ' : advertiserId + '.'}`
						)
					: `${advertisersIds.length} advertisers`}
			</span>
		</Fragment>
	);
};
